import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as lightbox from '#utilities/js/lightboxes/lightbox.js'
import { close } from '#utilities/js/lightboxes/lightbox.js'
import alert from '#utilities/js/ea/alert.js'
import { render } from '#utilities/js/template/template.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import { elements } from '../../../styles.js'
import * as generics from '#components/generics/js/styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const isAvailable = (evt, start, duration) => {
  return (Number(evt.start) >= (start + duration)) || ((Number(evt.start) + Number(evt.duration)) <= start)
}

const appendResource = async (
  origin
) => {
  const template = one(`.${elements.resourcesModal} > slot > template`, origin)
  const resource = await render(template)
  const modal = closest(`.${generics.elements.modal}`, origin)
  const opener = lightbox.opener(modal)
  const form = closest('form', opener)
  const container = one(`.${elements.resourcesList} ul`, form)

  append(container, resource)
}

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: async (
    form
  ) => {
    const { dataset } = one(`.${elements.schedule}`, form)
    const { scopeJson } = dataset
    const json = JSON.parse(scopeJson)
    let available = true

    if (json) {
      const start = one('[type="hidden"][name="start"]', form)
      const duration = one('[type="hidden"][name="duration"]', form)

      if (duration && Number(duration.value) === 86400) {
        if (json.length > 0) {
          available = false
        }
      } else if (start && duration) {
        for (const evt of json) {
          available = isAvailable(evt, Number(start.value), Number(duration.value))

          if (!available) {
            break
          }
        }
      }
    }

    if (available) {
      await appendResource(form)
      close()
    } else {
      const { alert: message } = dataset
      if (message) {
        await alert(message)
      }
    }
  }
})
export default form => {
  onSubmit.listen(form)
}
